import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 12c0-4.414 3.586-8 8-8s8 3.586 8 8-3.586 8-8 8-8-3.586-8-8zm8-6.5A6.505 6.505 0 005.5 12c0 3.586 2.914 6.5 6.5 6.5s6.5-2.914 6.5-6.5-2.914-6.5-6.5-6.5zm-1 7.44l3.47-3.47 1.06 1.06L11 15.06l-2.53-2.53 1.06-1.06L11 12.94z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 3a9 9 0 00-9 9 9 9 0 009 9 9 9 0 009-9 9 9 0 00-9-9zM1.5 12C1.5 6.2 6.2 1.5 12 1.5S22.5 6.2 22.5 12 17.8 22.5 12 22.5 1.5 17.8 1.5 12zm9.44 1.376l4.242-4.243 1.06 1.06-5.302 5.304-3.182-3.181 1.06-1.061 2.122 2.12z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M24 6C14.058 6 6 14.058 6 24s8.058 18 18 18 18-8.058 18-18S33.942 6 24 6zM3 24C3 12.402 12.402 3 24 3s21 9.402 21 21-9.402 21-21 21S3 35.598 3 24zm18.88 2.751l8.483-8.485 2.122 2.12L21.88 30.994l-6.365-6.362 2.121-2.122 4.244 4.242z",
    clipRule: "evenodd"
  }))
};
export var CheckCircle = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});